import * as ABCya from '@abcya/abcya_phaser';
import gameData from '../../gameData';
import sKey from '../../SoundAssetKeys';
import { differentFadeIn } from '../inGame/createTitle';
import { customConvertToButton, unFillDot } from '../inGame/menuUI';
import { resetGamedata, pauseOut, restartAll } from '../inGame/pauseScreen';
import { textIn } from '../inGame/tweenTimelines';
import { createChooseShape } from './chooseShape';
import { resetSprinkleColors, toggleNext } from './nextBackHandler';


export function finalScreen(scene) {
    const rect = scene.add.rectangle(512,384,1024,768,0xfffeec,0).setDepth(7).setInteractive();
    const finalArr = [];
    const bttnContLeft = scene.add.container().setDepth(8);
    const bttnContRight = scene.add.container().setDepth(8);

    finalArr.push(ABCya.Images.addImage(349, 240, "Make Your Donut/Yum_Y",scene).setDepth(8).setAlpha(0));
    finalArr.push(ABCya.Images.addImage(471, 246, "Make Your Donut/Yum_U",scene).setDepth(8).setAlpha(0));
    finalArr.push(ABCya.Images.addImage(608, 242, "Make Your Donut/Yum_M",scene).setDepth(8).setAlpha(0));
    finalArr.push(ABCya.Images.addImage(712, 251, "Make Your Donut/Yum_Exclamation",scene).setDepth(8).setAlpha(0));
    const playAgain = ABCya.Images.addImage(384, 421, "Make Your Donut/Btn_PlayAgain",scene).setDepth(8);
    const makeAgain = ABCya.Images.addImage(634, 421, "Make Your Donut/Btn_MakeAnotherDonut",scene).setDepth(8);

    bttnContLeft.add(playAgain);
    bttnContRight.add(makeAgain);

    bttnContLeft.add(scene.add.text(384,521,"PLAY AGAIN",{fontFamily:'bpreplaybold',
    fontSize:'16px',
    align:'center',
    color:'#0099ad'}).setOrigin(.5,.5).setDepth(8));

    bttnContRight.add(scene.add.text(634,536,"MAKE ANOTHER\nDONUT",{fontFamily:'bpreplaybold',
    fontSize:'16px',
    align:'center',
    color:'#0099ad'}).setOrigin(.5,.5).setDepth(8));

    finalArr.push(bttnContLeft,bttnContRight);
    const timeline = scene.tweens.createTimeline();

    differentFadeIn(finalArr,timeline);

    timeline.play();

    timeline.on('complete',()=>{
        playAgain.setInteractive();
        makeAgain.setInteractive();
        customConvertToButton(playAgain);
        customConvertToButton(makeAgain);
        scene.custSound.playSoundCustom(sKey._yum);
    })

    playAgain.on('pointerover',()=>{
        scene.custSound.playSoundNoOverlap(sKey._play_again);
    });

    makeAgain.on('pointerover',()=>{
        scene.custSound.playSoundNoOverlap(sKey._make_another_donut);
    });

    if(scene.game.device.input.touch)
    {
        soundForTouch();
    }

    makeAgain.on('pointerup', ()=>{
        makeAgain.disableInteractive();
        let tween = pauseOut(finalArr,rect);
        tween.on('complete',async ()=>{
            unFillDot(1);
            unFillDot(2);
            unFillDot(3);
            unFillDot(4);
            scene.makeDonut.setAlpha(0);
            scene.sprinkleCont.removeAll(true);
            gameData.sprinkle = false;
            scene.rend.clear();
            textIn(scene,gameData.makeDoText[0],true,116);
            await createChooseShape(scene);
            toggleNext(scene);
            gameData.makeData.index = 1;
            scene.nextBut.setInteractive();
            scene.backBut.setInteractive();
        });
    });

    playAgain.on('pointerup',()=>{
        playAgain.disableInteractive();
        let tween = pauseOut(finalArr,rect);
        tween.on('complete',()=>{
            resetGamedata();
            restartAll(scene);
        });
    });

    function soundForTouch()
    {
        playAgain.on('pointerdown',()=>{
            scene.custSound.playSoundNoOverlap(sKey._play_again)
        });
    
        makeAgain.on('pointerdown',()=>{
            scene.custSound.playSoundNoOverlap(sKey._make_another_donut)
        });
    }
}